import React from 'react';

export function Button({
  as: Component = 'button',
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  leftIcon = null,
  rightIcon = null,
  children,
  className = '',
  type = 'button',
  ...props
}) {
  const isButton = Component === 'button';
  const buttonType = isButton ? type : undefined;
  const isDisabled = disabled || loading;

  const classes = [
    'bza-btn',
    `bza-btn-${variant}`,
    `bza-btn-${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Component
      type={buttonType}
      className={classes}
      disabled={isButton ? isDisabled : undefined}
      aria-disabled={isDisabled ? 'true' : undefined}
      {...props}
    >
      {loading ? (
        <span className="bza-btn-spinner" aria-hidden="true" />
      ) : (
        leftIcon && <span className="bza-btn-icon-left">{leftIcon}</span>
      )}
      <span>{children}</span>
      {!loading && rightIcon && (
        <span className="bza-btn-icon-right">{rightIcon}</span>
      )}
    </Component>
  );
}

export default Button;
